import React from 'react';
import { Link } from 'react-router-dom';

const Banner = ({ actionLink, bannerUrl, postTitle }) => {
  return (
    <>
      <Link to={actionLink} target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>
        <img src={bannerUrl} alt={postTitle} style={{ width: '100%', height: 'auto' }} />
      </Link>
    </>
  );
};

export default Banner;
